// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__OYoYH","wrapper":"Footer_wrapper__O67Gl","left":"Footer_left__fTz49","right":"Footer_right__huLDa"};